<div class="date-range-container flex justify-between" [ngClass]="className" role="group" [formGroup]="dateRangeForm">
    <mat-form-field appearance="outline" class="flex w-[180px]">
      <input (dateInput)="handleOnChange()" class="w-16" [disabled]="getIsDisabled()" matInput [matDatepicker]="startPicker" i18n-placeholder placeholder="Start Date" formControlName="startDate"  [errorStateMatcher]="matcher">
      <mat-datepicker-toggle [disabled]="getIsDisabled()" matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker [disabled]="getIsDisabled()" #startPicker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="flex w-[180px]">
      <input (dateInput)="handleOnChange()" class="w-16" [disabled]="getIsDisabled()" matInput [matDatepicker]="endPicker" i18n-placeholder placeholder="End Date" formControlName="endDate" [errorStateMatcher]="matcher">
      <mat-datepicker-toggle [disabled]="getIsDisabled()" matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker [disabled]="getIsDisabled()" #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
  @if(this.dateRangeForm && getErrorMessage()) {
    <div class="flex mb-2" [class]="className">
      <mat-error i18n>
        {{ getErrorMessage() }}
      </mat-error>
    </div>
}